module.exports = __webpack_public_path__ + "img/arrow-grain-right.a9eb7cd5.svg";